import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { capitalize, compact, isEmpty, map, split } from 'lodash-es';

type SurfaceInputType = string | number | undefined | null;

@Pipe({
  name: 'redSurface',
  standalone: false
})
export class SurfacePipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  transform(value: SurfaceInputType, unit = 'Sq Ft') {
    let result = value?.toString() || '';

    if (result) {
      const parsedUnit = result?.replace(/[^a-zA-Z]*/g, '').toLowerCase();
      const parsedValue = parseFloat(result?.replace(/[^\d.]*/g, ''));
      if (!isEmpty(parsedUnit) && !['sqft'].includes(parsedUnit)) {
        unit = compact(map(split(parsedUnit, ' '), capitalize)).join(' ');
      }
      if (isNaN(parsedValue)) {
        result = '0';
      } else {
        result = this.decimalPipe.transform(parsedValue) || '0';
      }
    } else {
      result = `--`;
    }

    if (unit === 'SF') {
      unit = 'Sq Ft';
    }

    return `${result} ${unit}`;
  }
}
